import React, { useEffect } from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import FAQ from "../../Components/FAQ";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

const FAQPage = ({ isLogin }) => {
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text={"سوالات متداول"} />
        <FAQ />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(FAQPage);
